import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-statistic',
    templateUrl: './templates/statistic.component.html',
    styleUrls: ['./styles/statistic.component.css']
})
export class StatisticComponent implements OnInit {

    constructor() {}

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/statistic.component.ts